export default __webpack_public_path__ + "static/media/11.d41d7541.png";